module.exports = __webpack_public_path__ + "static/img/good-detail-store.b39b6d7f.png";